import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Flex, GridItem, Icon, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, SimpleGrid, Tag, Text, useColorModeValue, useDisclosure, useToast } from "@chakra-ui/react";
import AuthApi from "Api/AuthApi";
import BillingApi from "Api/BillingApi";
import Storage from "Helpers/Storage";
import { useAuth } from "Providers/AuthProvider";
import { useLoading } from "Providers/LoadingProvider";
import { useEffect, useState } from "react";
import { FaCalendarPlus, FaCartPlus } from "react-icons/fa";
import { TbUser } from "react-icons/tb";
import { Pagination } from "react-laravel-paginex";
import Transaction from "./Components/Transaction";

function Account() {
    const user = useAuth().getUser();
    const [page, setPage] = useState(1);
    const loading = useLoading();
    const [data, setData] = useState({});
    const membershipModal = useDisclosure();

    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");
    const infoBg = useColorModeValue("gray.50", "gray.700");
    const textPrimary = useColorModeValue("gray.800", "white");
    const textMuted = useColorModeValue("gray.600", "gray.400");

    const getData = async (param) => {
        loading.show();
        let currentPage = param ? param.page : ( page || 1 );
        setPage(currentPage);
        let response = await BillingApi.transactions(currentPage);
        if (response.status === 200) {
            setData(response.json);
        }
        loading.hide();
    }

    async function loadUserData() {
        let user = await AuthApi.me();
        Storage.set('user', user.json.data);
    }

    useEffect( () => {
        getData({page: 1})
    }, []);

    useEffect(() => {
        var channel = window.pusher.subscribe('user_' + user.id);
        channel.bind('transaction-update', async function() {
            loading.show();
            await loadUserData();
            await getData();
            loading.hide();
        });

        return () => {
            window.pusher.unsubscribe('user_' + user.id);
        }
    }, []);

    return (
        <>
            <Box
                bg={cardBg}
                borderRadius="xl"
                overflow="hidden"
                boxShadow="md"
                border="1px solid"
                borderColor={borderColor}
            >
                <Box
                    bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)"
                    py={5}
                    px={6}
                >
                    <Flex align="center" gap={3}>
                        <Flex align="center" justify="center" bg="whiteAlpha.200" borderRadius="lg" p={2}>
                            <Icon as={TbUser} color="white" boxSize={6} />
                        </Flex>
                        <Box>
                            <Text color="white" fontWeight="bold" fontSize="xl">Minha Conta</Text>
                            <Text color="whiteAlpha.800" fontSize="sm">Gerenciar perfil e assinatura</Text>
                        </Box>
                    </Flex>
                </Box>

                <Box p={6}>
                    <SimpleGrid columns={{ sm: 1, lg: 5}} w="100%" gap={6}>
                        <GridItem colSpan={{ sm: 1, lg: 2 }}>
                            <Box bg={infoBg} borderRadius="lg" p={4}>
                                <Text fontSize="lg" fontWeight="bold" mb={4} color={textPrimary}>
                                    Informações Pessoais
                                </Text>
                                <Flex mb={2}>
                                    <Text fontWeight="semibold" mr={2} color={textMuted}>Nome:</Text>
                                    <Text color={textPrimary}>{user.name}</Text>
                                </Flex>
                                <Flex mb={2}>
                                    <Text fontWeight="semibold" mr={2} color={textMuted}>E-mail:</Text>
                                    <Text color={textPrimary}>{user.email}</Text>
                                </Flex>
                                <Flex mb={2}>
                                    <Text fontWeight="semibold" mr={2} color={textMuted}>Telefone:</Text>
                                    <Text color={textPrimary}>{user.phone}</Text>
                                </Flex>
                                <Flex mb={2}>
                                    <Text fontWeight="semibold" mr={2} color={textMuted}>Cidade:</Text>
                                    <Text color={textPrimary}>{user.city}/{user.state}</Text>
                                </Flex>
                                <Flex>
                                    <Text fontWeight="semibold" mr={2} color={textMuted}>Desde:</Text>
                                    <Text color={textPrimary}>{(new Date(user.created_at)).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</Text>
                                </Flex>
                            </Box>
                        </GridItem>

                        <GridItem colSpan={{ sm: 1, lg: 3 }} mt={{ sm: 0, lg: 0 }}>
                            <Flex w="100%" justifyContent="space-between" alignItems="center" mb={4}>
                                <Text fontSize="lg" fontWeight="bold" color={textPrimary}>
                                    Assinatura
                                </Text>
                                <Tag
                                    colorScheme={user.membership ? 'green' : 'red'}
                                    fontWeight="semibold"
                                    variant="solid"
                                    borderRadius="full"
                                    px={3}
                                >
                                    Assinatura {user.membership ? 'Ativa' : 'Suspensa'}
                                </Tag>
                            </Flex>

                            <Flex w="100%" justifyContent={{sm: "center", lg: "space-between"}} flexDirection={{ sm: "column", lg: "row"}} alignItems="center" mb={6}>
                                <Box>
                                    <Text fontWeight="semibold" color={textPrimary}>Válida até: {(new Date(user.membership_until)).toLocaleDateString('pt-BR', {timeZone: 'UTC'})}</Text>
                                    <Text textAlign={{sm: "center", lg: "left"}} fontSize="xs" color={textMuted}>({user.membership_until_in_days > 0 ? 'Faltam ' + user.membership_until_in_days + ' dias' : 'Expirado'})</Text>
                                </Box>
                                { user.membership_until_in_days <= 7 &&
                                    <Button
                                        onClick={membershipModal.onOpen}
                                        bg="brand.500"
                                        color="white"
                                        _hover={{ bg: "brand.600" }}
                                        leftIcon={<FaCalendarPlus/>}
                                        borderRadius="xl"
                                        mt={{ sm: 3, lg: 0 }}
                                    >
                                        Renovar Assinatura
                                    </Button>
                                }
                            </Flex>

                            <Box w="100%">
                                {
                                    data.data && data.data.map((transaction, k) => (
                                        <Transaction key={k} transaction={transaction} />
                                    ))
                                }
                            </Box>

                            <Pagination changePage={getData} data={data} nextButtonText="Próxima" prevButtonText="Anterior"/>
                        </GridItem>
                    </SimpleGrid>
                </Box>
            </Box>
            <MembershipPricesModal isOpen={membershipModal.isOpen} onClose={membershipModal.onClose} />
        </>
    )
}

function MembershipPricesModal({ isOpen, onClose }) {
    const loading = useLoading();
    const toast = useToast({
        position: "top-right",
    });
    const paymentInfoModal = useDisclosure();

    const cardBg = useColorModeValue("white", "gray.800");
    const borderColor = useColorModeValue("gray.200", "gray.700");

    const plans = {
        month: {
            name: 'Mensal',
            price: 'R$ 29,99',
            description: '30 Dias',
        },
        quarter: {
            name: 'Trimestral',
            price: 'R$ 74,99',
            description: '90 Dias',
        },
        semiannual: {
            name: 'Semestral',
            price: 'R$ 149,99',
            description: '180 Dias',
        },
        year: {
            name: 'Anual',
            price: 'R$ 299,99',
            description: '1 Ano',
        }
    };

    async function renew(plan)
    {
        loading.show();
        let response = await BillingApi.getCheckoutUrl(plan);
        if (response.status !== 200) {
            loading.hide();
            toast({ status: 'error', title: 'Houve um problema ao obter o link de checkout!', duration: 3000, variant: 'solid', isClosable: true });
            return;
        } else {
            let checkoutUrl = response.json.data;
            window.open(checkoutUrl, '_blank');
            loading.hide();
            setTimeout(() => {
                window.gtag('event', 'conversion', {
                    label_name: "Assinatura " + plans[plan]['name'],
                    value: plans[plan]['price'].replace('R$ ', '').replace('.', '').replace(',', '.'),
                });
                paymentInfoModal.onOpen();
                onClose();
            }, 500);
        }
    }

    return <>
        <Modal size={"2xl"} isOpen={isOpen} onClose={onClose}>
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
            <ModalContent borderRadius="2xl" overflow="hidden">
                <Box bg="linear-gradient(135deg, #2D6B3F 0%, #1F5A2F 100%)" py={4} px={6}>
                    <Text color="white" fontWeight="bold" fontSize="xl">Período da Assinatura</Text>
                    <Text color="whiteAlpha.800" fontSize="sm">Escolha o plano que melhor se encaixa para você</Text>
                </Box>
                <ModalCloseButton color="white" />
                <ModalBody pb={8} pt={6}>
                    <SimpleGrid gap={3} w="100%" columns={{ sm: 2, md: 4 }}>
                        {
                            Object.keys(plans).map((plan, k) => (
                                <PriceCard key={k} title={plans[plan]['name']} price={plans[plan]['price']} description={plans[plan]['description']} onClick={() => { renew(plan) }} cardBg={cardBg} borderColor={borderColor} />
                            ))
                        }
                    </SimpleGrid>
                </ModalBody>
            </ModalContent>
        </Modal>

        <AlertDialog isOpen={paymentInfoModal.isOpen} onClose={paymentInfoModal.onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        Informação
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        Após efetuar o pagamento, pode levar algum tempo para que o mesmo seja compensado em nosso sistema e sua assinatura renovada.<br/><br/>
                        <b>Cartão/Pix:</b> O pagamento é processado dentro de alguns minutos/horas.<br/>
                        <b>Boleto Bancário:</b> O pagamento é processado em até 3 dias úteis.<br/>
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button onClick={paymentInfoModal.onClose}>
                            Ok, entendi!
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    </>
}

function PriceCard({ title, price, description, onClick, cardBg, borderColor }) {
    return <Box
        p={5}
        w="100%"
        bg={cardBg}
        borderRadius="xl"
        boxShadow="md"
        border="1px solid"
        borderColor={borderColor}
        transition="all 0.2s"
        _hover={{ transform: "translateY(-4px)", shadow: "lg", borderColor: "brand.300" }}
    >
        <Flex flexDirection="column" alignItems="center">
            <Text fontSize="lg" fontWeight="semibold" mb={2}>{title}</Text>
            <Text fontSize="xl" fontWeight="bold" mb={2}>{price}</Text>
            <Text fontSize="xs" mb={3} opacity={0.7}>{description}</Text>

            <Button
                bg="brand.500"
                color="white"
                _hover={{ bg: "brand.600" }}
                size="sm"
                onClick={onClick}
                leftIcon={<FaCartPlus/>}
                borderRadius="lg"
                w="full"
            >
                Selecionar
            </Button>
        </Flex>
    </Box>
}

export default Account;
